import { appConfig } from '../../../../../config/customization';

const row = {
  cursor: 'pointer',
  borderBottom: `1px solid ${appConfig.colors.bordersGray}`,
  padding: '15px 0',
  ':hover': {
    fontWeight: 500
  }
};

export default {
  container: {
    padding: '30px 0'
  },
  listTitle: {
    paddingLeft: 30
  },
  categoryLabel: {
    fontSize: 16
  },
  categoryRow: {
    ...row,
    margin: '0 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  subcategoriesContainer: {
    transition: 'max-height 300ms',
    overflow: 'hidden',
    padding: '0 30px',
    maxHeight: 0,
    backgroundColor: appConfig.colors.activeRowColor
  },
  subcategoriesContainerActive: {
    maxHeight: 999
  },
  subcategoryRow: row
};
